import { useEffect } from 'react';
import { useConsentPreferences } from '@cbhq/ucpm-web';

import { rumSetTrackingConsent, toRumTrackingConsent } from './datadogRum';

// Grants or withdraws RUM tracking when the user changes their cookie choices.
export function useRumTrackingConsent(): void {
  const consent = toRumTrackingConsent(useConsentPreferences());

  useEffect(() => {
    rumSetTrackingConsent(consent);
  }, [consent]);
}
